import { render, staticRenderFns } from "./KettleSetting.vue?vue&type=template&id=33b3dd84&scoped=true"
import script from "./KettleSetting.vue?vue&type=script&lang=js"
export * from "./KettleSetting.vue?vue&type=script&lang=js"
import style0 from "./KettleSetting.vue?vue&type=style&index=0&id=33b3dd84&lang=scss&scoped=true"
import style1 from "./KettleSetting.vue?vue&type=style&index=1&id=33b3dd84&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b3dd84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b3dd84')) {
      api.createRecord('33b3dd84', component.options)
    } else {
      api.reload('33b3dd84', component.options)
    }
    module.hot.accept("./KettleSetting.vue?vue&type=template&id=33b3dd84&scoped=true", function () {
      api.rerender('33b3dd84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sysParam/KettleSetting.vue"
export default component.exports